import { defineStore } from 'pinia';
import type { ICalculationParameters } from '../types/ICalculationParameters';

interface AppState {
  language: string;
  subassemblies: Array<string>;
  calculationContract: number;
  calculationSaved: boolean;
  params: ICalculationParameters | Record<string, never>;
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    language: 'de',
    subassemblies: [],
    calculationContract: 0,
    calculationSaved: false,
    params: {},
  }),
  actions: {
    changeLanguage(lang: string) {
      this.language = lang;
    },
    setSubassemblies(list: Array<string>) {
      this.subassemblies = list;
    },
    setCalculationContract(contract: number) {
      this.calculationContract = contract;
    },
    setCalculationSaved(saved: boolean) {
      this.calculationSaved = saved;
    },
    setParams(params: ICalculationParameters) {
      this.params = params;
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
